import SubHeader from "./SubHeader"

export default  SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/SubHeader/index.js